import { createContext, useContext, type ReactNode } from "react";

const RequestCloseContext = createContext<(() => void) | undefined>(undefined);
RequestCloseContext.displayName = "RequestCloseContext";

interface RequestCloseProviderProps {
  children: ReactNode;
  onRequestClose: () => void;
}

export const RequestCloseProvider = ({
  children,
  onRequestClose,
}: RequestCloseProviderProps) => (
  <RequestCloseContext.Provider value={onRequestClose}>
    {children}
  </RequestCloseContext.Provider>
);

export const useRequestClose = () => {
  const onRequestClose = useContext(RequestCloseContext);

  if (!onRequestClose) {
    throw new Error("useRequestClose must be used within RequestCloseProvider");
  }

  return onRequestClose;
};
